require('./modifyDebitLimitsErrorStep.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
// @constants
const {
    BANK_PHONE_NUMBER_CLIENTS_ONLY_1,
} = require('constants/index');

class ModifyDebitLimitsErrorStep extends React.Component {
    render() {
        const { immCard, processType } = this.props;

        const cardId = immCard.get('cardId');
        const cardAlias = immCard.getIn(['alias', 'current']);

        const title = formatText('cardModifyDebitLimits-errorTitle');

        const goBackButton = {
            label: formatText('cards-backToCard', [cardAlias]).toUpperCase(),
            url: `/myprofile/cards/${cardId}/details`
        };

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}
                    processType={processType}
                >
                    <section className="row no-gutter">
                        <div className="col-xs-6 col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-6 col-md-7">
                            <FormattedText value="cardModifyDebitLimits-errorMessage" />
                            <div className="modify-debit-limits-error__icons-block">
                                <i className="modify-debit-limits-error__icon icon-s-llamar"/>
                                <p className="modify-debit-limits-error__phone-number">{BANK_PHONE_NUMBER_CLIENTS_ONLY_1}</p>
                                <i className="modify-debit-limits-error__icon  modify-debit-limits-error__icon--right-icon icon-s-llamar"/>
                                <p className="modify-debit-limits-error__phone-number"><FormattedText value="cardModifyDebitLimits-phoneNumberClients" /></p>
                            </div>
                        </div>
                    </section>
                </WizardError>
            </div>
        );
    }
}

ModifyDebitLimitsErrorStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardModifyDebitLimits: PropTypes.object.isRequired,
    processType: PropTypes.string.isRequired,
};

module.exports = ModifyDebitLimitsErrorStep;
